import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-content">
          {/* Column 1 */}
          <div className="footer-section">
            <div className="footer-logo-container">
              <img src="/aspen_logo.png" alt="Aspen Quick Care Logo" className="footer-logo-img" />
              <h3 className="footer-logo">Aspen Quick Care</h3>
            </div>
            <div className="legal-links">
              <a href="/terms-of-use">Terms of Use</a>
              <span>|</span>
              <a href="/privacy-policy">Privacy Policy</a>
              <span>|</span>
              <a href="/compliance">Compliance</a>
              <span>|</span>
              <a href="/hipaa">HIPAA</a>
            </div>
          </div>

          {/* Column 2 */}
          <div className="footer-section">
            <h4>About</h4>
            <ul className="footer-links">
              <li><a href="/about">About</a></li>
              <li><a href="/services">Our Services</a></li>
              <li><a href="/#insurance">Insurances</a></li>
              <li><a href="/careers">Careers</a></li>
            </ul>
          </div>

          {/* Column 3 */}
          <div className="footer-section">
            <h4>Services</h4>
            <ul className="footer-links">
              <li><a href="/urgent-care">Urgent Care</a></li>
              <li><Link to="/primary-care">Primary Care</Link></li>
              <li><a href="/physicals">Physicals</a></li>
            </ul>
          </div>

          {/* Column 4 - Contact */}
          <div className="footer-section">
            <h4>Contact</h4>
            <ul className="footer-links">
              <li><a href="mailto:bettercare@aspenquickcare.com" className="email-link">Email Us</a></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
